import {AUTH, KAPPA , KAPPA_SERVICES, ENV} from "../constants";
import axios from 'axios'

export default class {
    constructor() {
        this.authCookie = this.getCookie(AUTH.AUTH_COOKIE_NAME);
        this.http = axios.create({
            headers:
                {
                    'Authorization': `Bearer ${this.authCookie}`
                }
        })
    }

    /**
     * return an array containing the chat stats
     * @param channel
     * @param params
     * @returns {Promise}
     */
    getStats(channel, params) {
        const url = `${KAPPA}/${KAPPA_SERVICES.CHATSTATS}/${channel}/stats`;
        return this.get(url, params);
    }

    /**
     * return an array containing the available channels
     * @param url
     * @param limit
     * @returns {Promise}
     */
    getChannels(limit) {
        const url = `${KAPPA}/${KAPPA_SERVICES.CHATSTATS}/`;
        return this.get(url, {limit});
    }

    getUsers(search) {
        const url = `${KAPPA}/${KAPPA_SERVICES.CHATSTATS}/search?channel=${search}`;
        return this.get(url);
    }

    searchChannels(searchKey) {
        const url = `${KAPPA}/${KAPPA_SERVICES.CHATSTATS}/search`;
        return this.get(url, {channel: searchKey});
    }


    get(url, params) {
        return this.http.get(url, {params});
    }

    post(url, body, params) {
        return this.http.post(url, body, {params})
    }

    getCookie(name) {
        let value = '; ' + document.cookie
        let parts = value.split('; ' + name + '=')
        if (parts.length === 2) {
            return parts.pop().split(';').shift()
        }
        return null
    }

    deleteCookie(name) {
        let domain = ENV === 'development' ? 'localhost' : '.streamelements.com';
        document.cookie = `${name}=; path=/; domain=${domain}; expires=` + new Date(0).toUTCString()
    }
}



// WEBPACK FOOTER //
// ./src/services/Api.js